import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function validateInteger(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === '') {
      return null;
    }

    const integerRegex = /^-?\d+$/;

    if (integerRegex.test(`${value}`)) {
      return null;
    }

    return { integer: true };
  };
}
